export default "__VITE_ASSET__BK3D6tZF__"